import * as workerTimers from 'worker-timers';
import { useState, useEffect } from 'react';

const Timer = ({ timer, changeTimer, handleExamScore, process = '', state = '' }) => {
  const [minutes, setMinutes] = useState<number>(0);
  const [seconds, setSeconds] = useState<number>(0);
  var downTimeId: number | null = null;

  useEffect(() => {
    setDefaultTime();
  }, [timer]);

  useEffect(() => {
    switch (state) {
      case 'start':
        downTimeId = setTimeoutDownTime();
        break;
      case 'pause':
        clearDownTimeWorker();
        break;
      case 'stop':
        setDefaultTime();
        break;
      default:
        break;
    }
  }, [state]);

  useEffect(() => {
    if (state) {
      return;
    }

    process == 'complete' ? setWorkTime() : setDefaultTime();
  }, [process]);

  useEffect(() => {
    if (['init', 'complete'].includes(process) || ['stop', 'pause'].includes(state)) {
      return;
    }

    downTimeId = setTimeoutDownTime();
    return () => {
      clearDownTimeWorker();
    };
  }, [seconds, process]);

  const setDefaultTime = () => {
    setMinutes(timer);
    setSeconds(0);
  }

  const setWorkTime = () => {
    const work_time = `${zeroPrefix(timer - minutes - 1)}:${zeroPrefix(60 - seconds)}`;
    const isTimeUp = minutes == 0 && seconds == 0;
    changeTimer({
      homework_time: `${zeroPrefix(timer)}:00`, work_time,
    }, isTimeUp);
  }

  const setTimeoutDownTime = () => {
    return workerTimers.setTimeout(() => {
      if (timer == 0) return;
      let newSeconds = seconds;
      let newMinutes = minutes;

      if (newSeconds > 0) {
        newSeconds = newSeconds - 1;
        setSeconds(newSeconds);
      } else if (seconds === 0 && minutes > 0) {
        newMinutes = newMinutes - 1;
        newSeconds = 59;
        setMinutes(newMinutes);
        setSeconds(newSeconds);
      }

      if (state == 'start') {
        changeTimer({ timer, seconds: newSeconds, minutes: newMinutes })
      }

      if (newMinutes === 0 && newSeconds === 0 && handleExamScore) {
        handleExamScore();
      }

      clearDownTimeWorker();
    }, 1000)
  }

  const clearDownTimeWorker = () => {
    if (downTimeId) {
      workerTimers.clearTimeout(downTimeId);
      downTimeId = null;
    }
  }

  const zeroPrefix = (number: number = 0) => {
    return number < 10 ? `0${number}` : number;
  }

  return (
    <span className="font-weight-bold">
      {zeroPrefix(minutes)}:{zeroPrefix(seconds)}
    </span>
  )
}

export default Timer;
